import React from 'react';
import { Header } from '../../Components/partial/Header';
import ContactArea from './ContactArea';
import BradCaump from '../../Components/partial/BradCaump';
import Footer from '../../Components/footer';



const Contact = () => {
  return (
    <>
    
             <Header/>
            <BradCaump />
            <ContactArea/>
            <Footer/>
            
         
    
   


    </>
  )
}

export default Contact